(function() {
  const runShippingLogic = () => {
    const containers = document.querySelectorAll('.shipping-logic-active');
    
    containers.forEach(container => {
      const atcButton = document.querySelector('form[action*="/cart/add"] [type="submit"], .product-form__submit, [name="add"]');
      
      const isOutOfStock = () => {
        if (!atcButton) return false;
        const btnText = atcButton.innerText.toLowerCase();
        return atcButton.hasAttribute('disabled') || 
               btnText.includes('sold out') || 
               btnText.includes('unavailable') || 
               btnText.includes('продано') || 
               btnText.includes('épuisé');
      };

      if (isOutOfStock()) { container.style.display = 'none'; return; }

      const t = {
        inStock: container.getAttribute('data-lang-in-stock'),
        today: container.getAttribute('data-lang-today'),
        tomorrow: container.getAttribute('data-lang-tomorrow'),
        arrivesBy: container.getAttribute('data-lang-arrives-by'),
        arrives: container.getAttribute('data-lang-arrives'),
        or: container.getAttribute('data-lang-or'),
        order_within: container.getAttribute('data-lang-order-within'),
        hrs: container.getAttribute('data-lang-hrs'),
        mins: container.getAttribute('data-lang-mins')
      };

      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
      let titleNode, subtitleNode;
      let node;
      while(node = walker.nextNode()) {
        if (node.textContent.includes("SHIPPING_PLACEHOLDER")) titleNode = node;
        if (node.textContent.includes("COUNTDOWN_PLACEHOLDER")) subtitleNode = node;
      }

      if (!titleNode || !subtitleNode) return;

      const update = () => {
        if (isOutOfStock()) { container.style.display = 'none'; return; }

        const now = new Date();
        const et = new Date(now.toLocaleString("en-US", {timeZone: "America/New_York"}));
        const day = et.getDay(); 
        const hr = et.getHours();
        const cutoff = 16; 
        
        let targetShipDate = new Date(et);
        let arrivalDays = 2; 

        // SHIPPING WINDOW LOGIC
        if (day >= 1 && day <= 3 && hr < cutoff) {
          targetShipDate.setHours(cutoff, 0, 0, 0);
          arrivalDays = 2;
        } 
        else if ((day === 3 && hr >= cutoff) || (day === 4 && hr < cutoff)) {
          if (day === 3) targetShipDate.setDate(et.getDate() + 1); 
          targetShipDate.setHours(cutoff, 0, 0, 0);
          arrivalDays = 1; 
        }
        else if (day >= 1 && day <= 2 && hr >= cutoff) {
          targetShipDate.setDate(et.getDate() + 1);
          targetShipDate.setHours(cutoff, 0, 0, 0);
          arrivalDays = 2;
        }
        else {
          let daysToMonday = (1 - day + 7) % 7;
          if (daysToMonday === 0) daysToMonday = 7;
          targetShipDate.setDate(et.getDate() + daysToMonday);
          targetShipDate.setHours(cutoff, 0, 0, 0);
          arrivalDays = 2;
        }

        const currentLocale = Shopify.locale || document.documentElement.lang || 'en';
        const dateOptions = { weekday: 'long', month: 'short', day: 'numeric' };
        
        const formatLocaleDate = (date) => {
          let str = date.toLocaleDateString(currentLocale, dateOptions);
          return str.charAt(0).toUpperCase() + str.slice(1);
        };

        const diffInMs = targetShipDate - et;
        const midnightEt = new Date(et).setHours(0,0,0,0);
        const midnightTarget = new Date(targetShipDate).setHours(0,0,0,0);
        const diffInDays = Math.round((midnightTarget - midnightEt) / (1000 * 60 * 60 * 24));
        const isShippingToday = (et.toDateString() === targetShipDate.toDateString());

        // TITLE
        let displayTitle = `${t.inStock} `;
        if (isShippingToday && hr < cutoff) {
          displayTitle += t.today;
        } else if (diffInDays === 1) {
          displayTitle += t.tomorrow;
        } else {
          displayTitle += formatLocaleDate(targetShipDate);
        }
        titleNode.textContent = displayTitle.toUpperCase();

        // SUBTITLE
        let subtitleHTML = "";
        if (isShippingToday && hr < cutoff) {
          let arrivalDate = new Date(targetShipDate);
          arrivalDate.setDate(arrivalDate.getDate() + arrivalDays);
          const arriveStr = formatLocaleDate(arrivalDate);
          const h = Math.floor(diffInMs / 3600000);
          const m = Math.floor((diffInMs % 3600000) / 60000);
          
          if (arrivalDays === 1) {
            subtitleHTML = `${t.arrives} <strong>${t.tomorrow.toLowerCase()}</strong>. `;
          } else {
            const endDot = arriveStr.endsWith('.') ? "" : ".";
            subtitleHTML = `${t.arrives} <strong>${t.tomorrow.toLowerCase()}</strong> ${t.or} <strong>${arriveStr}</strong>${endDot} `;
          }
          subtitleHTML += `${t.order_within} <span style="color: #008000;">${h} ${t.hrs} ${m} ${t.mins}</span>.`;
        } else {
          // RANGE MODE FIX
          let rangeStart = new Date(targetShipDate);
          if (arrivalDays === 1) {
             rangeStart.setDate(rangeStart.getDate() + 1);
             const startStr = formatLocaleDate(rangeStart);
             const endDot = startStr.endsWith('.') ? "" : ".";
             subtitleHTML = `${t.arrivesBy} <strong>${startStr}</strong>${endDot}`;
          } else {
             rangeStart.setDate(rangeStart.getDate() + 1);
             let rangeEnd = new Date(targetShipDate);
             rangeEnd.setDate(rangeEnd.getDate() + 2);
             const startStr = formatLocaleDate(rangeStart);
             const endStr = formatLocaleDate(rangeEnd);
             const endDot = endStr.endsWith('.') ? "" : ".";
             subtitleHTML = `${t.arrives} <strong>${startStr}</strong> ${t.or} <strong>${endStr}</strong>${endDot}`;
          }
        }
        
        subtitleNode.parentNode.innerHTML = subtitleHTML;
        container.style.display = 'block';
      };

      update();
      setInterval(update, 60000);
    });
  };

  document.addEventListener('DOMContentLoaded', runShippingLogic);
  document.addEventListener('shopify:section:load', runShippingLogic);
  window.addEventListener('popstate', runShippingLogic);
  document.addEventListener('click', () => setTimeout(runShippingLogic, 200)); 
  setTimeout(runShippingLogic, 500);
})();